<template>
  <div id="products" class="px-4">
    <brand-list />
  </div>
</template>
<script>
import BrandList from "@/components/brand_management/BrandList";

export default {
  components: {
    BrandList
  },
  data: () => ({}),
  computed: {}
};
</script>

<style></style>
